module.exports = __webpack_public_path__ + "img/img_balloon_red.58cfebad.png";